import { api_react_v1_insights_path } from '../../routes';
import request from './request';

export interface Insight {
  top_results: [string, number];
  total_count: number;
}

export async function getInsight(entitySource, entitySourceAttribute, limit): Promise<Insight> {
  const resp = await request(
    'get',
    api_react_v1_insights_path({
      entity_source: entitySource,
      entity_source_attribute: entitySourceAttribute,
      limit: limit,
    })
  );
  return resp;
}
